import { useMutation } from '@tanstack/react-query';

import { DocumentRelationObject } from '../../../../types';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { postDocumentRelation } from '../../requests/postDocumentRelation';
import { DocumentParams } from '../../types/DocumentParams';

export const useAttachDocumentRelation = () => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({
      documentId,
      documentParams,
      data,
    }: {
      documentId: string;
      documentParams: DocumentParams;
      data: DocumentRelationObject;
    }) => postDocumentRelation(constructPost, documentId, documentParams, data),
  });

  return { attachDocumentRelation: mutateAsync, isPending };
};
